function closeWrapper(w, duration = 150) {
    if (!w) return;
    w.classList.remove('active');
    const c = w.querySelector('.filter-content');
    if (c) fadeOut(c, duration);
}

function handleBtnFilter(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const wrapper = button.closest('.filter-wrapper');
    const content = wrapper ? wrapper.querySelector('.filter-content') : null;

    document.querySelectorAll('.filter-wrapper.active').forEach((w) => {
        if(w === wrapper) return;
        closeWrapper(w);
    });

    if(!wrapper || !content) return;

    if(wrapper.classList.contains('active')){
        closeWrapper(wrapper);
    }else{
        wrapper.classList.add('active');
        fadeIn(content, 150);
    }
}

document.addEventListener('click', (e) => {
    if(e.target.closest('.filter-wrapper')) return;
    document.querySelectorAll('.filter-wrapper.active').forEach((w) => {
        closeWrapper(w);
    });
});

function handleDepth2Open(e) {
    const depth1Content = document.querySelector('.depth1-content');
    const filter = e.currentTarget.dataset.filter;
    const now_depth2Content = document.querySelector(`.depth2-content[data-filter="${filter}"]`);
    depth1Content.classList.add('hidden');
    now_depth2Content.classList.remove('hidden');
}

function handleDepth2Close(e) {
    const depth1Content = document.querySelector('.depth1-content');
    const filter = e.currentTarget.dataset.filter;
    const now_depth2Content = document.querySelector(`.depth2-content[data-filter="${filter}"]`);
    depth1Content.classList.remove('hidden');
    now_depth2Content.classList.add('hidden');
}

async function handleFilterFormSubmit(e){
    e.preventDefault();
    const form = document.getElementById('CollectionFilterFormMo');
    const formData = new FormData(form);
    const params = makeSearchParamsObject(formData.entries());
    const now_search_params = makeSearchParamsString(params);
    const new_url = `${window.location.pathname}?${now_search_params}`;
    updateFilterOptionHtml(new_url);
}

function handleFilterAnchorClick(href) {
    updateFilterOptionHtml(href);
} 

function handleSortChange(e) {
    const sort = e.currentTarget.value;
    const params = getNowSearchParams();
    params.sort_by = [sort];

    const now_search_params = makeSearchParamsString(params);    
    updateFilterOptionHtml(`${window.location.pathname}?${now_search_params}`);
}

let price_input_timeout;
function handlePriceInputChange(e) {
    clearTimeout(price_input_timeout);
    let value = e.currentTarget.value;

    if(isNaN(value)){
        clearTimeout(price_input_timeout);
    }

    value = parseInt(value);

    const key = e.currentTarget.name;
    const params = getNowSearchParams();
    const max = parseInt(e.currentTarget.max);

    if(value <= 0){
        value = 0;
    }else if(value >= max){
        value = max;
    }else{
        value = value;
    }

    price_input_timeout = setTimeout(() => {
        params[key] = [value];
        const now_search_params = makeSearchParamsString(params);
        const new_url = `${window.location.pathname}?${now_search_params}`;
        
        updateFilterOptionHtml(new_url);
    }, 300);
}

function updateFilterOptionHtml(url){
    const filterform = document.querySelector('filter-form');
    const productlist = document.querySelector('product-list');
    const loadingWrapper = document.querySelector('.loading-wrapper.filter');
    loadingWrapper.classList.add('active');
    fetch(url)
        .then(response => response.text())
        .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newfilterform = html.querySelector('filter-form');
            const newproductlist = html.querySelector('product-list');

            filterform.innerHTML = newfilterform.innerHTML;
            productlist.innerHTML = newproductlist.innerHTML;
            
            history.replaceState({}, '', `${url}`);

            if(window.innerWidth < 821){
                handleSideModalClose('filter');
            }
        })
        .catch(error => {
            console.error('Error updating filter form:', error);
        })
        .finally(() => {
            loadingWrapper.classList.remove('active');
        });
}